<div class="p-0">
    <div class="modal-dialog modal-info-panel m-0" role="document">
        <bcu-local-spinner [size]="40" [visible]="(courtClass$ | async).isLoading"
            *ngIf="(courtClass$ | async).isLoading">
        </bcu-local-spinner>
        <div class="modal-content modal-info-panel"
            *ngIf="(courtClass$ | async).loaded && (courtClass$ | async).data as courtClass">
            <div class="modal-header info-panel-bg-color white">

                <div class="modal-title blocked-slot-info-title d-flex flex-column flex-grow-1">
                    <div class="flex-grow-1 text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="flex-grow-1 text-center">
                        <div class="info-panel-title">{{ courtClass.name }}
                        </div>
                    </div>
                    <div class="flex-grow-1 text-center mt-1">
                        <div class="info-panel-sub-title" translate>CourtClass.Title</div>
                    </div>

                </div>

            </div>
            <div class="modal-body p-0 info-panel-players">

                <div class="blocked-slot-info-content d-flex flex-column p-3 info-panel-bg-color">
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_calendar"></span></div>
                        <div>{{courtClass.date | bcDate :"dddd, MMM Do YYYY"}}</div>
                        <div class="flex-grow-1 text-right">
                            <app-court-event-status-pill [infoPanel]="true" [status]="courtClass.status">
                            </app-court-event-status-pill>
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic-cb-time"></span></div>
                        <div>{{courtClass.timeFromInMinutes| timeDisplay}} -
                            {{courtClass.timeToInMinutes | timeDisplay}}
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic_bs_court"></span></div>
                        <div>{{courtClass.court.name}}<span *ngIf="courtClass.court.tennisType"
                                class="blocked-slot-tennis-type">
                                ({{courtClass.court.tennisType.name}})</span></div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <div class="mr-3"><span class="ic-person"></span></div>
                        <div *ngIf="!courtClass.substituteInstructor && courtClass.instructor">
                            {{courtClass.instructor.name}}
                        </div>
                        <div *ngIf="courtClass.substituteInstructor">{{courtClass.substituteInstructor.name}}</div>
                    </div>
                    <div class="flex-grow-1 d-flex">
                        <hr class="solid bg-white" style="width: 100%;">
                    </div>
                    <div class="flex-grow-1 d-flex" *ngIf="isAnyNote(courtClass)">
                        <app-court-event-notes-info [notes]="courtClass.notes"></app-court-event-notes-info>
                    </div>

                    <div class="flex-grow-1 d-flex py-1">
                        <span class="clickable" (click)="onAddNote()">{{'CourtClass.AddNote' | translate}}</span>
                    </div>

                    <div class="d-flex flex-grow-1">
                        <button class="btn btn-grey-outline flex-grow-1 mt-2" (click)="details()"
                            translate>CourtClass.DetailsButton</button>
                        <a class="btn btn-grey-outline flex-grow-1 mt-2 ml-2 pt-2" target="_blank"
                            href="{{ groupClassesUrl() }}"> {{'CourtClass.OpenBtn' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>